// (2 Oct 2026) Shared by the poll pages: when the signed-in person is a
// member's secondary contact on this calendar, returns that member's
// preferred name (for "Signed in as: Allan of Turea & Allan"), else null.
// Asked per calendar via GET /api/calendars/:id/me/identity; cleared
// whenever the calendar changes so a stale name never shows.
import { useState, useEffect } from 'react';

export default function useSecondaryOf(apiBaseUrl, authToken, calendarId) {
  const [secondaryOf, setSecondaryOf] = useState(null);
  useEffect(() => {
    setSecondaryOf(null);
    if (!calendarId || !authToken || !apiBaseUrl) return undefined;
    let cancelled = false;
    fetch(`${apiBaseUrl}/api/calendars/${calendarId}/me/identity`, {
      headers: { 'Authorization': `Bearer ${authToken}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!cancelled && d && d.role === 'secondary') setSecondaryOf(d.primaryPreferredName || null);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [apiBaseUrl, authToken, calendarId]);
  return secondaryOf;
}
